export class ScanData {
    public userInfo!: any;
    public groupInfo!: any;
}
